export default class Main {

	constructor() {
		this.init();
	}

	init() {

        /* inizio gestione transizioni siti */
				$('.sidebars [data-link]').on('click',function(){
					$('.info-modal--btn').css({
						transform: 'translateY(100px)'
					})
					var target = $(this).attr('data-target'),
									origin = $(this).attr('data-origin'),
									link = $(this).attr('data-link')
					$('html,body').addClass('transitioning')
					$('.sidebar--'+target).addClass('sidebar--expanded')
					$('.sidebar--expanded .logo').fadeOut(500)
					setTimeout(function(){
									// $('.sidebar--expanded .logo').addClass('logo--expanded')
									// $('.logo--expanded').fadeIn(500)
                                    $('.logo--transition').fadeIn(500)
					},1500)
					setTimeout(function(){
						//$('body').addClass('wait')
						window.location.href = link
					},4000)
        })        

        const urlParams = new URLSearchParams(window.location.search);
        const transition = urlParams.get('transition');
        if(transition) {
                $('.current')
                        .addClass('sidebar--expanded')
                $('html,body')
                        .addClass('transitioning')
                        .addClass('transitioning-in')
                $('.current .logo')
                        .addClass('logo--expanded')
                
                setTimeout(function(){
                    $('.logo--expanded').fadeOut(1500)
                },1500)

								setTimeout(function(){
									$('html,body')
										.removeClass('wait')
									$('.current').css({
										transition: 'all 1.5s ease-in-out',
										opacity:0
									})
                                    $('.section--hero--homepage .brands--slides').slick('reinit')
								},3000)

                setTimeout(function(){
									$('.current').remove()
									$('.sidebars > *').css({
										transition: 'opacity 1.5s ease-in-out',
										opacity:1
									})
									$('html,body')
											.removeClass('transitioning')
											.removeClass('transitioning-in')
                },4500)
                setTimeout(function(){
                    $('.section--hero--homepage .brands--links--item:nth-child(1)').trigger('mouseenter')
                },5000)
        }
        else {
                $('body').removeClass('wait')
        }        
        /* fine gestione transizioni siti */

        $('.transition-mobile--toggle').on('click', function() {
            $('body,html').toggleClass('transition-mobile--modal--open')
        })



        function debounce(method) {
            clearTimeout(method._tId);
            method._tId= setTimeout(function(){
                method();
            }, 150);
        }

        let aosSettings = {
            once: true, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them          
        }

        AOS.init(aosSettings)

        if($('.home-hero-v1 .slide').length < 2)
        {
            $('.home-hero-v1 .slider-v1--navigation').remove()
        }

        $('.home-hero-v1 .slider-v1--slides')
            .on( 'init', function(event, slick, direction){
                let slider = $(slick.$slider[0]),
                    arrows = slider.parent().find('.arrows--pagination')

                arrows.find('.prev').addClass('disabled')

                arrows.find('.prev').on('click',function(){
                    slider.slick('slickPrev')
                })
                arrows.find('.next').on('click',function(){
                    slider.slick('slickNext')
                })
                arrows.find('.last').html($(slick.$slides).length)

                $('.home-hero-v1 .slider-v1--slides .slider-v1--arrow')
                    .off('click').on('click')
                    .on('click', function(){
                        slider.slick('slickNext')
                    })
                })
            .on( 'afterChange', function(event, slick, currentSlide, nextSlide){
                let slider = $(slick.$slider[0]),
                    slides = $(slick.$slides),
                    arrows = slider.parent().find('.arrows--pagination')

                arrows.find('.disabled').removeClass('disabled')
                
                arrows.find('.current').html(currentSlide+1)

                if(currentSlide == 0)
                {
                    arrows.find('.prev').addClass('disabled')
                }

                if(currentSlide == slides.length-1)
                {
                    arrows.find('.next').addClass('disabled')
                }
            })
            .slick({
                autoplay: true,
                autoplaySpeed: 5000,    
                fade:true,
                arrows: false,
                dots: false,
                speed: 1500,
            }) 


        window.dropdownsInit = function()
        {
            $('.dropdown--link').on('click', function(e){
                if($(this).hasClass('active'))
                {
                    $(this).removeClass('active')
                    $(this).parent().find('.dropdown--list').toggle(500)
                    return
                }
                $('.dropdown--link.active').parent().find('.dropdown--list').toggle(500)
                $('.dropdown--link.active').removeClass('active')
                $(this).addClass('active')
                $(this).parent().find('.dropdown--list').toggle(500)
            })
        }
        window.dropdownsInit()

        $('.section--hero--homepage .brands--slides')
            .on( 'init', function(){
                var slider = $('.section--hero--homepage .brands--slides')
                $('.section--hero--homepage .brands--links--item').on('mouseenter', function(e){
                    var index = parseInt($(this).attr('data-slide-index'))
                    slider.slick('slickGoTo', index - 1);
                })
                // su mobile non devono seguire il link, ma azionare lo slider
                if( screen.width < 992) // @include media-down(sm)
                {
                    $('.section--hero--homepage .brands--links--item').removeAttr('target')
                    $('.section--hero--homepage .brands--links--item').removeAttr('href')

                    $('.section--hero--homepage .brands--links--item')
                    .off('click')
                    .on('click', function(e){
                        e.preventDefault()
                        var index = parseInt($(this).attr('data-slide-index'))
                        slider.slick('slickGoTo', index - 1)
                        return false
                    })
                }
            })
            .slick({
                arrows: false,
                infinite: false,
                dots: false,
                fade:true,
                speed:1000,
                //draggable: false,
                //useCSS: false,
            })            


        // filtri newsroom
        $('.newsroom .newsroom-list').imagesLoaded( function() {
            // images have loaded
            $('.newsroom .newsroom-list').isotope({
                itemSelector: '.newsroom-list-item',
                masonry:
                {
                    //columnWidth: '.sizer',
                    //horizontalOrder: true
                }
            })
            
            AOS.init(aosSettings)

            $('.filters .filter').on('click', function(e){
                if($(this).find('input').prop('checked'))
                {
                    $(this).find('input').prop('checked', false)
                    $('.newsroom-list').isotope({
                        filter: '*'
                    })    
                    return
                }
                $('.filters').find('input').prop('checked', false)
                $(this).find('input').prop('checked', true)
                $('.newsroom-list').isotope({
                    filter: $(this).attr('data-filter')
                })
                AOS.init(aosSettings)
            })
        })

        // filtri careers
        $('.careers-list').imagesLoaded( function() {
            // images have loaded
            $('.careers-list').isotope({
                itemSelector: '.careers-list-item',
                masonry:
                {
                    //columnWidth: '.sizer',
                    //horizontalOrder: true
                }
            })
            
            AOS.init(aosSettings)

            $('.filters .filter').on('click', function(e){
                if($(this).find('input').prop('checked'))
                {
                    $(this).find('input').prop('checked', false)
                    $('.careers-list').isotope({
                        filter: '*'
                    })    
                    return
                }
                $('.filters').find('input').prop('checked', false)
                $(this).find('input').prop('checked', true)
                $('.careers-list').isotope({
                    filter: $(this).attr('data-filter')
                })
                AOS.init(aosSettings)
            })
        })

        // modals (newsroom + careers)
        $('[data-modal-open]').on('click', function(e){
            let modal = $($(this).attr('data-modal-open'))
            let ajax = $(this).parent().attr('data-modal-ajax')
            modal.show(0, function(){
                $('body,html').addClass('modal-open')
                window.ajaxModal(ajax)
            })
            setTimeout(function(){
                window.uxAjaxSetup()
                $('.slick-initialized').parent().find('.prev').trigger('click')
            },500)
        })
        
        $('[data-modal-close], [data-modal-close] *').on('click', function(e){
            if($('body').hasClass('modal-open'))
            {
                e.preventDefault()
            }
            $('body,html').removeClass('modal-open')
            let modal = $(this).closest('.modal')
            setTimeout(function(){
                modal.hide(0)    
            },1500)
        })

        window.newsroomSliderInit = function newsroomSliderInit()
        {
            // slider dettaglio newsroom e modal newsroom
            $('.newsroom-detail-slider .slides:not(.slick-initialized)')
                .on( 'init', function(event, slick, direction){
                    let slider = $(slick.$slider[0]),
                        arrows = slider.parent().find('.arrows--pagination')

                    arrows.find('.prev').addClass('disabled')

                    arrows.find('.prev').on('click',function(){
                        slider.slick('slickPrev')
                    })
                    arrows.find('.next').on('click',function(){
                        slider.slick('slickNext')
                    })
                    arrows.find('.last').html($(slick.$slides).length)
                })
                .on( 'afterChange', function(event, slick, currentSlide, nextSlide){
                    let slider = $(slick.$slider[0]),
                        slides = $(slick.$slides),
                        arrows = slider.parent().find('.arrows--pagination')

                    arrows.find('.disabled').removeClass('disabled')
                    
                    arrows.find('.current').html(currentSlide+1)

                    if(currentSlide == 0)
                    {
                        arrows.find('.prev').addClass('disabled')
                    }

                    if(currentSlide == slides.length-1)
                    {
                        arrows.find('.next').addClass('disabled')
                    }
                })
                .slick({
                    arrows: false,
                    infinite: false,
                    dots: false,
                })
        }

        // al load della pagina
        window.newsroomSliderInit()


        // setup UX in caso di elementi caricati in asincrono come le modali di careers e newsroom
        window.uxAjaxSetup = function()
        {
            $('.share, .image, .boxed, .text').removeClass('aos-init')
            $('.share, .image, .boxed, .text').removeAttr('data-aos')
            $('.share, .image, .boxed, .text').removeAttr('data-aos-duration')
            $('.share, .image, .boxed, .text').removeAttr('data-aos-delay')
            window.dropdownsInit()
            window.newsroomSliderInit()
            $('.modal .section-ctas a')
                .off('click')
                .removeAttr('href')
            $('.modal .section-ctas').on('click', function(){
                $(this).closest('.modal').find('.modal-close').trigger('click')
            })
        }
        

        // section slider
        $('.section-slider .slides')
            .on( 'init', function(event, slick, direction){
                let slider = $(slick.$slider[0]),
                    arrows = slider.parent().find('.nav')

                arrows.find('.prev').addClass('disabled')
            })
            .on( 'afterChange', function(event, slick, currentSlide, nextSlide){
                let slider = $(slick.$slider[0]),
                    slides = $(slick.$slides),
                    arrows = slider.parent().find('.nav')

                arrows.find('.disabled').removeClass('disabled')

                if(currentSlide == 0)
                {
                    arrows.find('.prev').addClass('disabled')
                }

                if(currentSlide == slides.length-1)
                {
                    arrows.find('.next').addClass('disabled')
                }

                setTimeout(function(){
                    slider.removeClass('slider--transition-in')
                },300)
            })
            .slick({
                arrows: false,
                infinite: false,
                dots: false,
                variableWidth: true,
                //draggable: false,
                useTransform: false,
                //useCSS: false,
            })            

        $('[data-nav-selector] .prev').on('click', function(e){
            if($(this).hasClass('disabled')) return
            let selector = $(this).closest('[data-nav-selector]').attr('data-nav-selector')
            $(selector).addClass('slider--transition-in')
            setTimeout(function(){
                $(selector).slick('slickPrev')
            },300)
        })

        $('[data-nav-selector] .next').on('click', function(e){
            if($(this).hasClass('disabled')) return
            let selector = $(this).closest('[data-nav-selector]').attr('data-nav-selector')
            $(selector).addClass('slider--transition-in')
            setTimeout(function(){
                $(selector).slick('slickNext')
            },300)
        })



        if($('.custom-cursor').length)
        {
            $('body').append('<div class="cursor"><span>Hold<br>& drag</span></div>')
            
            let cursor = $('.cursor')

            $('.custom-cursor')
                .on('mousemove', function(e) {
                    cursor.css({
                        top: e.clientY - cursor.height() / 2,
                        left: e.clientX - cursor.width() / 2
                    })
                })
                .on('mouseleave',function() {
                    cursor.css({
                        display: "none"
                    })
                })
                .on('mouseenter',function() {
                    cursor.css({
                        display: "inline"
                    })
                })   
                
            $('.arrows')
                .on('mouseleave',function() {
                    cursor.css({
                        opacity: 1
                    })
                })
                .on('mouseenter',function() {
                    cursor.css({
                        opacity: 0
                    })
                })
            
        }

        // menu
        $('.menu-toggle').on('click', function(){
            if($('body,html').hasClass('menu-open'))
            {
                $('body,html').toggleClass('menu-open')    
                setTimeout(function(){
                    $('.menu').toggle(0)
                },250)
            }
            else
            {
                $('.menu').toggle(0)
                $('body,html').toggleClass('menu-open')    
            }
        })


        // scroll button
        $('[data-scroll]').on('click', function(e){
            let selector = $(this).attr('data-scroll'),
                headerHeight = $('.header').outerHeight()
            $('html,body')
                .stop()
                .animate({
                    scrollTop: $(selector).offset().top// - 2*headerHeight
                },1000)
        })

        document.scrollingElement.scrollTo(0, 0)
        gsap.registerPlugin(ScrollTrigger)

        ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
                gsap.utils.toArray('.images--gallery').forEach((section) => {            
                    const w = section.querySelector('.images--list')
                    const [x, xEnd] = ['50%', (w.scrollWidth - section.offsetWidth*0.5) * -1]
                    gsap.fromTo(w, {  x  }, {
                        x: xEnd,
                        scrollTrigger: { 
                            trigger: section, 
                            //scrub: 0.5,
                            scrub:true,
                        }
                    })
                })
            }
        })   
        
        $('.images--list').slick({
            responsive: [
                {
                  breakpoint: 9999,
                  settings: 'unslick'
                },
                {
                  breakpoint: 767,
                  settings: {
                        dots: false,
                        infinite: true,
                        speed: 300,
                        arrows:false,
                        centerMode: true,
                    }
                }
            ]            
        });                  
        

        // effetti comparsa titoli
        const splitLines = document.querySelectorAll("[data-split-lines]")
        //const splitWords = document.querySelectorAll("[data-split-words]")
        //const splitChars = document.querySelectorAll("[data-split-chars]")

        function splits()
        {
            splitLines.forEach((item) => {
                item.split = new SplitText(item, { 
                    type: "lines,words",
                    linesClass: "split-line"
                })
                gsap.from(item, {
                    scrollTrigger: {
                      start: 'top bottom',
                      end: 'bottom top',
                      trigger: item,
                      //toggleClass: 'in-view'
                      onEnter: () => { item.classList.add('in-view') }
                    }
                })                
            })

            /*
            splitWords.forEach((item) => {
                item.split = new SplitText(item, { 
                    type: "words",
                    linesClass: "split-word"
                })
                gsap.from(item, {
                    scrollTrigger: {
                      start: 'top bottom',
                      end: 'bottom top',
                      trigger: item,
                      //toggleClass: 'in-view'
                      onEnter: () => { item.classList.add('in-view') }
                    }
                })
            })

            splitChars.forEach((item) => {
                item.split = new SplitText(item, { 
                    type: "chars",
                    linesClass: "split-char"
                })
                gsap.from(item, {
                    scrollTrigger: {
                      start: 'top bottom',
                      end: 'bottom top',
                      trigger: item,
                      //toggleClass: 'in-view'
                      onEnter: () => { item.classList.add('in-view') }
                    }
                })
            })
            */
        }

        setTimeout(function(){
            splits()
            $('body').addClass('splitted-texts')
        },1000)


        if($('.section-pinned-on-scroll').length)
        {

            let pinnedScrollHandler = function()
            {
                var element = document.querySelector('.section-pinned-on-scroll'),
                    domRect = element.getBoundingClientRect(),
                    spaceBelowSection = window.innerHeight - domRect.bottom,
                    threshold = window.innerHeight - (window.innerHeight*0.4 + $('.pin.active').height())

                if( ($('.pinned .contents').offset().top - $(window).scrollTop()) <  window.innerHeight*0.4 )
                {
                    $('.pinned .pins').addClass('fixed')

                    if(spaceBelowSection >= threshold )
                    {
                        $('.pinned .pins')
                            .removeClass('fixed')
                            .addClass('scrolled')
                    }
                    else
                    {
                        $('.pinned .pins')
                            .removeClass('scrolled')
                            .addClass('fixed')
                    }                
                }
                else
                {
                    $('.pinned .pins').removeClass('fixed')
        
                    if(spaceBelowSection >= threshold )
                    {
                        $('.pinned .pins')
                            .removeClass('fixed')
                            .addClass('scrolled')
                    }              
                }

                $('.contents--item').each(function(e){
                    if( ($(this).offset().top - $(window).scrollTop()) - 75 <  window.innerHeight*0.4 )
                    {
                        $('.pin.active').removeClass('active')
                        $( $(this).attr('data-pin') ).addClass('active')
                        /*
                        let oldActive = $('.pin.active'),
                            newActive = $( $(this).attr('data-pin') )

                        if (newActive.hasClass('active')) return

                        oldActive
                            .removeClass('active')
                        
                        setTimeout(function(){
                            oldActive
                                .find('[data-split-lines]')
                                .each(function(s){
                                    $(this).removeClass('in-view')
                                })
                        },250)
                        
                        newActive
                            .find('[data-split-lines]')
                            .each(function(s){
                                $(this).removeClass('in-view')
                            })

                        newActive.addClass('active')
                        
                        setTimeout(function(){
                            newActive
                                .find('[data-split-lines]')
                                .each(function(s){
                                    $(this).addClass('in-view')
                                })
                        },250)*/                       
                    }
                })
            }


            window.addEventListener('scroll', pinnedScrollHandler )

        }

        let options = {
            /* vecchia conf nel caso in cui 
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            variableWidth: true
            */
            speed: 10000,
            autoplay: true,
            autoplaySpeed: 0,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            //infinite: false,
            arrows: false,
            dots: false,
        }
   
        $('.section--newsroom--slider .newsroom-list')
            .on( 'afterChange', function(event, slick, currentSlide, nextSlide){
                let slides = $(slick.$slides)
                if(currentSlide == (slides.length-1))
                {
                    $('.section--newsroom--slider .newsroom-list')
                        .slick('unslick')
                        .slick(options)
                }
            })
            .slick(options) 
            


        function setScrollSectionsWidths() 
        {
            //window.console.log('scroll-sections')
            $('[data-block-section]').each(function(e){
                let section = $(this),
                    sectionMinWidth = 0
                
                    
                section.find('*[data-block-item]').each(function(i){
                    sectionMinWidth += $(this).innerWidth()
                    //$(this).addClass('hidden')
                })

                section.parent().css({
                    minWidth: sectionMinWidth
                })
            })
        }

        $('.brands .page').imagesLoaded( function() {

            $('.section--hero--title').addClass('in-view')

            let scroller = document.querySelectorAll('.brands .page')[0]

            if(scroller == undefined) return
            
            let page = $('.brands .page')
            
            if(screen.width > 767.98)
            {
                setScrollSectionsWidths()

                setTimeout(function(){
                    setScrollSectionsWidths()
                },1000)
                
                $('[data-block-section]').each(function(e){
                    let section = $(this),
                        sectionMinWidth = 0
    
                    section.find('*[data-block-item]').each(function(i){
                        sectionMinWidth += $(this).innerWidth()
                        $(this).addClass('hidden')
                    })
    
                    section.parent().css({
                        minWidth: sectionMinWidth
                    })
                })
        
                $('.brands [data-scroll]').on('click', function(e){
                    let target = $(this).attr('data-scroll')
                    goToSection($(target))
                })
    
                scroller.onwheel = (event) => {
    
                    let scrollerWidth = 0,
                        offsetLeft = page.scrollLeft(),
                        wrapperWidth = page.innerWidth()
    
                    $('.section--brand--scroll').each(function(e){
                        scrollerWidth += $(this).innerWidth()
                    })
    
                    if( offsetLeft+wrapperWidth >= scrollerWidth )
                    {
                        if( event.deltaY>0 ) return
    
                        if ( $('html,body').scrollTop() > 0 ) return
                    }
    
                    event.preventDefault();
    
                    page
                        .stop()
                        .animate({
                            scrollLeft: page.scrollLeft() + event.deltaY
                        },0)
                };

                function goToSection(target)
                {
                    let offset = target.offset().left,
                        offsetParent = page.scrollLeft()
                        page.stop().animate({
                            scrollLeft: offset + offsetParent
                        },
                            Math.abs(offset) * 0.5
                        )
                }
                
                let scrollHandler = function()
                {
                    $('.section--brand--scroll').each(function(s){
                        let section = $(this),
                            anchor = $('[data-section-scroll="#'+ section.attr('id') +'"]')

                        if(anchor == undefined | anchor == null) anchor = $('[data-section-scroll=".'+ section.attr('id') +'"]')
                            
                        let hiddenBlocks = section.find('[data-block-item]')

                        if(hiddenBlocks.length > 0)
                        {
                            hiddenBlocks.each(function(e){
                                let block = $(this)
                                if(!block.hasClass('hidden')) return
                                if(block.offset().left < (screen.width-100)) block.removeClass('hidden')
                            })
                        }

                        if(section.offset().left < 200)
                        {
                            page.attr('data-current-section', '#'+section.attr('id'))

                            if(section.hasClass('active-scroll-section')) return
                            $('.active-scroll-section').removeClass('active-scroll-section')
                            section.addClass('active-scroll-section')

                            if(anchor.hasClass('active-scroll-anchor')) return
                            $('.active-scroll-anchor').removeClass('active-scroll-anchor')
                            anchor.addClass('active-scroll-anchor')
                        }
                    })
                }
                                        
                $('.brands *[data-section-scroll]').on('click', function(e){
                    let target = $($(this).attr('data-section-scroll'))
                    goToSection(target)
                })
    
                page.on('scroll', function()
                {
                    debounce( scrollHandler )
                    debounce( setScrollSectionsWidths )
                })
            }
            
            $('.brand-detail-slider .slides:not(.slick-initialized)')
                .on( 'init', function(event, slick, direction){
                    let slider = $(slick.$slider[0]),
                        arrows = slider.parent().find('.arrows--pagination')

                    arrows.find('.prev').addClass('disabled')

                    arrows.find('.prev').on('click',function(){
                        slider.slick('slickPrev')
                    })
                    arrows.find('.next').on('click',function(){
                        slider.slick('slickNext')
                    })
                    arrows.find('.last').html($(slick.$slides).length)
                })
                .on( 'afterChange', function(event, slick, currentSlide, nextSlide){
                    let slider = $(slick.$slider[0]),
                        slides = $(slick.$slides),
                        arrows = slider.parent().find('.arrows--pagination')

                    arrows.find('.disabled').removeClass('disabled')
                    
                    arrows.find('.current').html(currentSlide+1)

                    if(currentSlide == 0)
                    {
                        arrows.find('.prev').addClass('disabled')
                    }

                    if(currentSlide == slides.length-1)
                    {
                        arrows.find('.next').addClass('disabled')
                    }
                })
                .slick({
                    arrows: false,
                    dots: false,
                    infinite: false,
                    speed: 1500,
                    fade:true,
                })     

        })

	}

}

const main = new Main();
